import React, {Dispatch, SetStateAction, useCallback, useState} from "react"
import {IssueDB, IssueMeta} from "../../../models/IssueDB.model"
import {IssueTable} from "../IssueTable"
import styles from "./index.module.scss"
import {NewOrEditIssue} from "../NewIssue"

interface ListIssuesProps {
  db: IssueDB
  dbReplCnt: number
  setDBReplCnt: Dispatch<SetStateAction<number>>
}

export const ListIssues = (props: ListIssuesProps) => {
  const {db, dbReplCnt, setDBReplCnt} = props
  const issues = Object.keys(db.all)
    .map(key => db.all[key] as IssueMeta)
    .filter(i => i.id != null)
    .sort((a, b) => b.createAt - a.createAt)
  const numRequests = issues.length
  const [showCreateIssue, setShowCreateIssue] = useState<boolean>(false)

  const onCancelCreateNewIssue = useCallback(() => {
    setShowCreateIssue(false)
  }, [])

  const onClickNewIssue = useCallback(() => {
    setShowCreateIssue(true)
  }, [])

  return (
    <div className={styles.Container}>
      <div className={styles.HeaderRow}>
        <div className={styles.TitleCol}>
          <div className={styles.Subtitle}>
            There are total {numRequests} of feature requests in backlog
          </div>
        </div>
        <button className={styles.NewIssueBtn}
                onClick={onClickNewIssue}
        >
          New issue
        </button>
      </div>

      <IssueTable issues={issues}/>

      <NewOrEditIssue open={showCreateIssue}
                      onClose={onCancelCreateNewIssue}
                      db={db}
                      dbReplCnt={dbReplCnt}
                      setDBReplCnt={setDBReplCnt}
                      isNew={true}
      />
    </div>
  )
}
